"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRules = exports.JurisdictionRules = exports.FederalRules = exports.JURISDICTIONS = exports.KNOWN_JURISDICTIONS = void 0;
exports.isKnownJurisdiction = isKnownJurisdiction;
exports.resolveAccumulation = resolveAccumulation;
const states_1 = require("encamp-shared/dist/constants/states");
const CA_1 = require("./CA");
const FEDERAL_1 = require("./FEDERAL");
/**
 * Adding a state means one class file under this directory — carrying its
 * own expectations, which the sweep holds it to — and one registry entry
 * below. A state's numbers are regulatory law: verify them against that
 * state's own regulations, never assume them from another state's.
 */
/**
 * The jurisdictions the registry makes claims about — deliberately not a
 * `when` axis; the sweep runs once per jurisdiction. Anything absent falls
 * back to federal law, a property the runner checks rather than a set of
 * rows.
 */
exports.KNOWN_JURISDICTIONS = ["FEDERAL", "CA"];
function isKnownJurisdiction(value) {
    return exports.KNOWN_JURISDICTIONS.some((j) => j === value);
}
// Note that resolveAccumulation will automatically use the federal one for a
// valid 2-letter state abbreviation that is missing from here, so no need
// to create entries for a state that just uses the federal rules.
//
// Additionally, note that these are singletons instantiated at module load;
// These classes should never carry any state, only static constants and
// pure functions.
exports.JURISDICTIONS = {
    FEDERAL: new FEDERAL_1.FederalRules(),
    CA: new CA_1.CaliforniaRules(),
};
function resolveAccumulation(jurisdiction, ctx) {
    if (jurisdiction === null) {
        return exports.JURISDICTIONS.FEDERAL.resolve(ctx);
    }
    if (!(0, states_1.isStateAbbreviation)(jurisdiction)) {
        throw new Error(`Unrecognized facility state ${JSON.stringify(jurisdiction)} — expected a two-letter uppercase ` +
            `abbreviation or null.`);
    }
    if (!isKnownJurisdiction(jurisdiction)) {
        return exports.JURISDICTIONS.FEDERAL.resolve(ctx);
    }
    return exports.JURISDICTIONS[jurisdiction].resolve(ctx);
}
var FEDERAL_2 = require("./FEDERAL");
Object.defineProperty(exports, "FederalRules", { enumerable: true, get: function () { return FEDERAL_2.FederalRules; } });
Object.defineProperty(exports, "JurisdictionRules", { enumerable: true, get: function () { return FEDERAL_2.JurisdictionRules; } });
Object.defineProperty(exports, "StateRules", { enumerable: true, get: function () { return FEDERAL_2.StateRules; } });
//# sourceMappingURL=index.js.map